import React, { useState, useEffect } from "react";
import "../../../styles/calculate.css";
import ContractDetailCard from "./contract-detail.jsx"
import StipendCard from "./stipends.jsx"
import BonusCard from "./bonuses.jsx"
import BenefitCard from "./benefits.jsx"
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import { useNavigate } from "react-router-dom";
import Modal from 'react-modal';
import { formatWithCommas } from "../../helpers/common";
import { catchError } from '../../helpers/catch-error';
import SubscribedLink from '../safeguard/subscribed-link';






const Calculate = () => {
    const navigate = useNavigate();
    const [pageLoad, setPageLoad] = useState(true);
    const [isBtn, setIsBtn] = useState(false);
    const [contract, setContract] = useState(null);
    const [stipends, setStipends] = useState(null);
    const [benefits, setBenefits] = useState(null);
    const [bonuses, setBonuses] = useState(null);
    const [historyModalOpen, setHistoryModalOpen] = useState(false);
    const [historyEditMode, setHistoryEditMode] = useState(false);
    const [history, setHistory] = useState(null);
    const [historyChecked, setHistoryChecked] = useState([]);

    const [contractAll, setContractAll] = useState(0.00);
    const [contractTakeHomePay, setContractTakeHomePay] = useState(0.00);
    const [contractTaxes, setContractTaxes] = useState(0.00);
    const [contractStipend, setContractStipend] = useState(0.00);

    const [weeklyAll, setWeeklyAll] = useState(0.00);
    const [weeklyTakeHomePay, setWeeklyTakeHomePay] = useState(0.00);
    const [weeklyTaxes, setWeeklyTaxes] = useState(0.00);
    const [weeklyStipend, setWeeklyStipend] = useState(0.00);
    const [weeklyTakeHomePayPercentage, setWeeklyTakeHomePayPercentage] = useState(0.00);


    const social_security_tax = 6.2;
    const medicare_tax = 1.45;

    useEffect(() => {

        document.title = 'Roam Pays: Calculate your tax';
        document.body.style.zoom = 1.0


        // PROFILE VALIDATION CHECK ON PAGE LOAD
        const storedUserStr = localStorage.getItem('@roampays-user');
        let profileIncomplete = true;

        if (storedUserStr) {
            const cachedUser = JSON.parse(storedUserStr);
            if (
                cachedUser.filing_status_id && cachedUser.filing_status_id > 0 &&
                cachedUser.state_id && cachedUser.state_id > 0
            ) {
                profileIncomplete = false;
            }
        }

        if (profileIncomplete) {
            Swal.fire({
                icon: "warning",
                title: "Complete Your Profile for Better Results",
                text: "To provide the most accurate take-home pay and per diem calculations, please complete your profile information first.",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Go to My Profile",
                cancelButtonText: "Cancel"
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate("/profile");
                }
            });
            
        }




        const p1 = getContract();

        const p2 = getStipends();
        const p3 = getBonuses();
        const p4 = getBenefits();

        getHistory();


        Promise.all([p1, p2, p3, p4]).then(() => {

            setPageLoad(false);

        });


    }, []);

  
    useEffect(() => {

        calculateTakeHomeIncome();

    }, [contract, stipends, benefits, bonuses]);


    useEffect(() => {

        console.log(historyChecked);

    }, [historyChecked]);



    const calculateTakeHomeIncome = async () => {

        if (contract && contract.location_id > 0 && contract.duration > 0 && contract.hourly_rate > 0 && contract.shift_schedule_id > 0) {
setPageLoad(true);

            const hourly_rate = contract.hourly_rate;
            const weekly_hours = contract.days * contract.hours;
            const weekly_pay = weekly_hours * hourly_rate;
            const yearly_pay = (weekly_pay * 52.1429).toFixed(2);
            const total_pay = weekly_hours * contract?.duration * hourly_rate;

            const weekly_stipend = stipends?.reduce((total, { stipend_amount }) => total + stipend_amount, 0);
            const total_stipend = weekly_stipend * contract?.duration;


            setContractAll(total_pay + total_stipend);
            setContractStipend(total_stipend);
            setWeeklyAll(weekly_stipend+weekly_pay);
            setWeeklyStipend(weekly_stipend);



            axios.post(process.env.REACT_APP_API_URL + "/get-taxes", {
                yearly_pay: yearly_pay,
                location_id: contract.location_id,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {

                        const federal_tax = response?.data?.federal_tax;
                        const state_tax = response?.data?.state_tax;

                        const federal_tax_amount = (federal_tax / 100 * weekly_pay)
                        const state_tax_amount = (state_tax / 100 * weekly_pay);
                        const social_security_tax_amount = social_security_tax / 100 * weekly_pay
                        const medicare_tax_amount = medicare_tax / 100 * weekly_pay

                        const weekly_take_home_pay = weekly_pay - federal_tax_amount - state_tax_amount - social_security_tax_amount - medicare_tax_amount;
                        const weekly_taxes = weekly_pay - weekly_take_home_pay;

                        setWeeklyTakeHomePay(weekly_take_home_pay);
                        setWeeklyTaxes(weekly_taxes);
                        setContractTaxes(weekly_taxes * contract?.duration)
                        setContractTakeHomePay(total_pay - (weekly_taxes * contract?.duration))


                        const percentage = weekly_take_home_pay * 100 / weekly_pay;
                        setWeeklyTakeHomePayPercentage(percentage.toFixed(2));
setPageLoad(false);
                    }


                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Error", text: error.message });

                });




        }

    }

    const getContract = async () => {

        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_API_URL + "/get-contract", {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {
                        setContract(response.data.contract);
                    }
                    resolve(1);

                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Error", text: error.message });

                });
        })
    }

    const getStipends = async () => {

        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_API_URL + "/get-stipends", {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {
                        setStipends(response?.data?.stipends);
                    }
                    resolve(1);


                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Stipends", text: error.message });


                });
        })
    }

    const getBenefits = async (resolve, reject) => {

        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_API_URL + "/get-benefits", {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    if (response?.data?.status) {
                        setBenefits(response?.data?.benefits);
                    }
                    resolve(1);

                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Benefits", text: error.message });


                });
        })
    }

    const getBonuses = async (resolve, reject) => {

        return new Promise((resolve, reject) => {
            axios.get(process.env.REACT_APP_API_URL + "/get-bonuses", {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    setBonuses(response?.data?.bonuses);
                    resolve(1);


                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Error", text: error.message });

                });
        })
    }

    const getHistory = async () => {

        axios.get(process.env.REACT_APP_API_URL + "/get-history", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                if (response?.data?.status) {
                    setHistory(response?.data?.history);
                }


            })
            .catch(function (error) {
                catchError(error, navigate);
            });

    }
    const clearAll = async () => {

        setPageLoad(true);

        let a1 = axios.get(process.env.REACT_APP_API_URL + "/remove-contract", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                setContract(null);

            })
            .catch(function (error) {
                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


        let a2 = axios.post(process.env.REACT_APP_API_URL + "/remove-stipends", {}, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                setStipends(null);

            })
            .catch(function (error) {
                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


        let a3 = axios.post(process.env.REACT_APP_API_URL + "/remove-benefits", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                setBenefits(null);

            })
            .catch(function (error) {
                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });

        let a4 = axios.post(process.env.REACT_APP_API_URL + "/remove-bonuses", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                setBonuses(null);

            })
            .catch(function (error) {
                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });

        Promise.all([a1, a2, a3, a4]).then(() => {

            Swal.fire({ icon: "success", title: "", text: "All data cleared successfully." });
            setContract(null);
            setWeeklyTakeHomePay(0.00);
            setPageLoad(false);



        });





    }


    const getPerDiem = async (city, state, contract_id) => {
    const year = new Date().getFullYear();
    const month = new Date().getMonth(); // 0-based
    const normalizedCity = city ? city.trim().toLowerCase() : "";

    const p1 = new Promise((resolve, reject) => {
        axios
            .get(
                `https://api.gsa.gov/travel/perdiem/v2/rates/city/${encodeURIComponent(city)}/state/${state}/year/${year}?API_KEY=${process.env.REACT_APP_GSA_API_KEY}`
            )
            .then((r) => {
                const rates = r?.data?.rates;
                if (!rates?.length) return resolve([0, 0]);

                const rateEntries = rates[0]?.rate;
                if (!rateEntries?.length) return resolve([0, 0]);

                // Case-insensitive city match
                const matchedRate = rateEntries.find(rt =>
                    rt?.city?.toLowerCase().includes(normalizedCity)
                );

                // Fallback: first entry if no match
                const selectedRate = matchedRate || rateEntries[0];

                const housing =
                    selectedRate?.months?.month?.[month]?.value ?? 0;

                const meals = selectedRate?.meals ?? 0;

                resolve([meals, housing]);
            })
            .catch((err) => {
                reject(err);
            });
    });

    const p2 = new Promise((resolve, reject) => {
        axios
            .get(
                `https://api.gsa.gov/travel/perdiem/v2/rates/conus/mie/${year}?API_KEY=${process.env.REACT_APP_GSA_API_KEY}`
            )
            .then((r) => {
                const rate = r?.data?.[0];
                const others = rate?.incidental ?? 0;
                resolve([others]);
            })
            .catch((err) => {
                reject(err);
            });
    });

    const pa = await Promise.all([p1, p2])
        .then((values) => {
            const meals = values[0][0];
            const housing = values[0][1];
            const others = values[1][0];

            axios.post(
                process.env.REACT_APP_API_URL + "/save-max-allowances-by-id/",
                {
                    contract_id: contract_id,
                    housing_max: housing,
                    meals_max: meals,
                    others_max: others,
                },
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );

            return [housing, meals];
        })
        .catch((error) => {
            console.log(error);
            return [0, 0];
        });

    return pa;
};



    const saveToContract = async () => {

        if (contract && contract.location_id > 0 && contract.duration > 0 && contract.hourly_rate > 0 && contract.shift_schedule_id > 0) {

            setIsBtn(true);

            if (contract.state_abbreviation && contract.city)
                await getPerDiem(contract.city, contract.state_abbreviation, contract.contract_id);

            axios.post(process.env.REACT_APP_API_URL + "/save-current-contract", {}, {
                headers: {
                    'Content-Type': 'application/json'
                },

                withCredentials: true
            })
                .then(function (response) {
                    if (response.data?.status) {


                        navigate("/contract/list");
                    }
                    else {
                        Swal.fire({ icon: "error", title: "Error", text: response.data?.message });

                    }
                    setIsBtn(false);

                })
                .catch(function (error) {
                    setIsBtn(false);

                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Error", text: error.message });

                });



        }
        else {
            Swal.fire({ icon: "error", title: "Error", text: "Please fill contract information." });
        }
    }

    const deleteHistory = async () => {

        setIsBtn(true);
        Swal.fire({
            title: "Are you sure, you want to delete this?",
            text: "You won't be able to revert this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {

                axios.post(process.env.REACT_APP_API_URL + "/delete-history", {}, {
                    headers: {
                        'Content-Type': 'application/json'
                    },

                    withCredentials: true
                })
                    .then(function (response) {
                        getHistory();
                        setIsBtn(false);


                    })
                    .catch(function (error) {
                        setIsBtn(false);

                        if (error.status == 403) navigate("/login")
                        else
                            Swal.fire({ icon: "error", title: "Error", text: error.message });

                    });


            }
            else {
                setIsBtn(false);

            }
        });


    }


    const historyItemChecked = async (event) => {

        console.log(event.target.checked)

        if (event.target.checked) {
            setHistoryChecked([...historyChecked, parseInt(event.target.value)]);
        }
        else {
            setHistoryChecked(
                historyChecked.filter(a => a != event.target.value)
            );
        }


    }

    const deleteHistoryChecked = async () => {

        setIsBtn(true);
        Swal.fire({
            title: "Are you sure, you want to delete this?",
            text: "You won't be able to revert this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {

                axios.post(process.env.REACT_APP_API_URL + "/delete-history-checked", {
                    history_ids: historyChecked
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    },

                    withCredentials: true
                })
                    .then(function (response) {
                        getHistory();
                        setHistoryChecked([]);
                        setIsBtn(false);


                    })
                    .catch(function (error) {
                        setIsBtn(false);

                        if (error.status == 403) navigate("/login")
                        else
                            Swal.fire({ icon: "error", title: "Error", text: error.message });

                    });


            }
            else {
                setIsBtn(false);

            }
        });


    }
    return (
        <>

            <div className="title-box ">
                <div className="flex-equal" ></div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white d-sm-none">Calculate</h3>
                <div className="flex-equal justify-content-end " >
                    <SubscribedLink
    className="btn btn-link fs-12 d-flex fd-row align-items-center"
    onAllowed={() => {
        setHistoryModalOpen(true);
        setHistoryEditMode(false);
    }}
>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99984 2.33317C4.42251 2.33317 2.33317 4.42251 2.33317 6.99984C2.33317 9.57717 4.42251 11.6665 6.99984 11.6665C9.21136 11.6665 11.0636 10.1282 11.5448 8.06319L11.3206 8.28738C11.0927 8.51515 10.7234 8.51509 10.4956 8.28725C10.2678 8.05942 10.2679 7.69007 10.4957 7.4623L11.6627 6.29563C11.7721 6.18625 11.9205 6.12481 12.0752 6.12484C12.23 6.12486 12.3783 6.18634 12.4877 6.29575L13.654 7.46242C13.8818 7.69026 13.8817 8.05961 13.6539 8.28738C13.4261 8.51515 13.0567 8.51509 12.8289 8.28725L12.7151 8.17337C12.172 10.8326 9.81953 12.8332 6.99984 12.8332C3.77818 12.8332 1.1665 10.2215 1.1665 6.99984C1.1665 3.77818 3.77818 1.1665 6.99984 1.1665C9.14068 1.1665 11.0115 2.3201 12.0255 4.03678C12.1894 4.31417 12.0974 4.67186 11.82 4.83572C11.5426 4.99958 11.1849 4.90755 11.0211 4.63016C10.2082 3.25407 8.71123 2.33317 6.99984 2.33317ZM6.99984 3.49984C7.322 3.49984 7.58317 3.761 7.58317 4.08317V6.68765L9.07341 7.68114C9.34147 7.85985 9.41391 8.22202 9.2352 8.49008C9.05649 8.75814 8.69432 8.83057 8.42626 8.65187L6.67626 7.4852C6.51398 7.37701 6.4165 7.19488 6.4165 6.99984V4.08317C6.4165 3.761 6.67767 3.49984 6.99984 3.49984Z" fill="white" />
                        </svg>

                    </SubscribedLink>
                </div>

            </div>


            {pageLoad ?

                <div className="p-32">
                    <Loading color={'#75f'} stroke={'20px'} size={'200px'} />
                </div>

                :
                <>

                    <div className="box g-32" >

                        <div className="fd-column g-8 flex-grow-1">
                            <div className="color-light fs-12" >
                                Weekly Take Home Pay
                            </div>
                            <div className="fd-column g-8" >
                                <div className="w-100 color-white fs-44" >${formatWithCommas(weeklyTakeHomePay+weeklyStipend)}</div>
                                {(contract && contract.location_id > 0 && contract.duration > 0 && contract.hourly_rate > 0 && contract.shift_schedule_id > 0) &&

                                    <div className="fd-row" >

                                        <div className="segment segment-green" style={{ flexBasis: (weeklyTakeHomePay*100  / (weeklyTakeHomePay+weeklyStipend)).toFixed(0) + "%" }} ></div>
                                        <div className="segment segment-purple" style={{ flexBasis: (weeklyStipend *100 / (weeklyTakeHomePay+weeklyStipend)).toFixed(0) + "%" }} ></div>

                                    </div>
                                }
                                {(contract && contract.location_id > 0 && contract.duration > 0 && contract.hourly_rate > 0 && contract.shift_schedule_id > 0) &&

                                    <div className="cal-fd-row fs-12 color-white g-8 align-items-center justify-content-space-between" >
                                        <div ><span className="color-green">{weeklyTakeHomePayPercentage}%</span> of your total pay is take-home</div>
                                        <SubscribedLink to="/calculate/details" className="btn btn-secondary fd-row align-items-center" >
                                            <label className="fs-12">View Breakdown</label>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.30227 6.99997L5.31787 4.01557L6.34907 2.98438L10.3647 6.99997L6.34907 11.0156L5.31787 9.98438L8.30227 6.99997Z" fill="white" />
                                            </svg>
                                        </SubscribedLink>
                                    </div>
                                }
                            </div>


                        </div>

                        <ContractDetailCard getContractDetails={getContract} />

                        <StipendCard getStipendsDetails={getStipends} contract={contract} />

                        <BonusCard getBonusesDetails={getBonuses} contract={contract} />

                        <BenefitCard getBenefitsDetails={getBenefits} contract={contract} />


                        <br />
                        <br />
                        <br />
                        <br />

                    </div>
                    {(contract && contract.location_id > 0 && contract.duration > 0 && contract.hourly_rate > 0 && contract.shift_schedule_id > 0) &&

                        <div className="form-action">

                            <div className="action-bar ">

                                <div className="button-box">

                                   {/* CLEAR BUTTON: Restricted to Subscribed Users Only */}
    <SubscribedLink as="span" onAllowed={clearAll}>
        <button className="btn btn-secondary" disabled={isBtn}>
            {isBtn ? <Loading size={'20px'} /> : 'Clear'}
        </button>
    </SubscribedLink>

    {/* SAVE BUTTON: Restricted to Subscribed Users Only */}
    <SubscribedLink as="span" onAllowed={saveToContract}>
        <button className="btn btn-primary" disabled={isBtn}>
            {isBtn ? <Loading size={'20px'} /> : 'Save'}
        </button>
    </SubscribedLink>
                                </div>
                            </div>

                        </div>
                    }

                </>
            }





            <Modal
                isOpen={historyModalOpen}
                onRequestClose={() => { setHistoryModalOpen(false) }}
                contentLabel="History"
                className="modal"
                overlayClassName="overlay"
                size="lg"
            >
                <div className="modal-title" >

                    <div className="flex-equal justify-content-start " ></div>
                    <h3 className="flex-equal justify-content-center fs-18 fs-helvetica  color-white">History</h3>
                    <div className="flex-equal justify-content-end" >
                        <div className="icon" onClick={() => setHistoryModalOpen(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M8.0312 7L10.8154 9.78423L9.78423 10.8154L7 8.0312L4.21577 10.8154L3.18457 9.78423L5.9688 7L3.18457 4.21577L4.21577 3.18457L7 5.9688L9.78424 3.18457L10.8154 4.21577L8.0312 7Z" fill="white" />
                            </svg>
                        </div>

                    </div>

                </div>


                <div className="modal-body min-height" >
                    <div className="box modal p-16" >




                        {history?.map((c, index) => {


                            return <>
                                {(index == 0 || (c.date_created != history[index - 1]?.date_created)) &&


                                    <div className="color-white fs-12 tt-uppercase "  >{c.date_created_formatted} </div>



                                }

                                <a href="/contract/list" className="fd-row p-12" >

                                    {historyEditMode &&
                                        <div className="align-self-center " style={{ flexBasis: "5%" }}  ><input type="checkbox" name="history[]" value={c.history_id} onClick={(e) => historyItemChecked(e)} /></div>
                                    }
                                    <div className="color-light fs-14 mr-3 align-self-center " style={{ flexBasis: (historyEditMode ? "40" : "45") + "%" }}  >${c.weekly_income.toFixed(2)} </div>
                                    <div className="flex-grow-1" >

                                        <div className="segment segment-green align-self-center" style={{ flexBasis: (c.take_home_income * 100 / c.total).toFixed(2) + "%" }} ></div>
                                        <div className="segment segment-brown align-self-center" style={{ flexBasis: (c.taxes * 100 / c.total).toFixed(2) + "%" }} ></div>


                                        <div className={"segment segment-purple align-self-center "} style={{ flexBasis: (c.stipends * 100 / c.total).toFixed(2) + "%" }}></div>
                                        <div className={"segment segment-pink align-self-center "} style={{ flexBasis: (c.benefits_and_bonuses * 100 / c.total).toFixed(2) + "%" }}></div>
                                    </div>
                                </a>
                            </>
                        })
                        }






                    </div>

                </div>
                <div className="modal-footer  justify-content-space-between" >
                    {historyEditMode ?
                        <>
                            <button className="btn btn-secondary" type="button" onClick={() => { setHistoryEditMode(false) }}>Done</button>
                            <button className={"btn " + (historyChecked?.length > 0 ? "btn-under" : "btn-secondary color-lighter")} type="button" onClick={() => {
                                if (historyChecked?.length > 0) deleteHistoryChecked();
                            }} >
                                Delete
                                {historyChecked?.length > 0 && ("(" + historyChecked?.length + ")")}
                            </button>

                        </>
                        :
                        <>
                            <button className="btn btn-secondary" type="button" onClick={() => { setHistoryEditMode(true) }}>Edit</button>
                            <button className="btn btn-under" type="submit" disabled={isBtn} onClick={deleteHistory} >
                                {isBtn ? <Loading size={'20px'} /> : 'Clear'}</button>

                        </>
                    }

                </div>


            </Modal>

        </>


    );
};

export default Calculate;